<template>
  <drawer-bottom show="{{ show }}" title="差旅制度" bind:close="close">
    <view class="es-travel-container">
      <view class="es-travel-container-header">
        <text>国内火车票</text>
      </view>
      <view class="es-travel-container-body">
        <view class="es-travel-container-body-item">
          <view class="es-travel-container-body-item-1">
            {{ trainInfoContent[0].name }}
          </view>
          <text class="es-travel-container-body-item-2">
            {{ trainInfoContent[0].value }}
          </text>
        </view>
        <view class="es-travel-container-body-item">
          <view class="es-travel-container-body-item-1">
            {{ trainInfoContent[1].name }}
          </view>
          <text class="es-travel-container-body-item-2">
            {{ trainInfoContent[1].value }}
          </text>
        </view>
      </view>
    </view>
  </drawer-bottom>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import initMixin from '@/mixins'

  createComponent({
    mixins: [initMixin],
    props: {
      show: Boolean,
      trainInfoContent: {
        type: Array,
        value: [
          {
            name: '',
            value: ''
          },
          {
            name: '',
            value: ''
          }
        ]
      }
    },
    data: {},
    computed: {},
    methods: {
      close() {
        this.$trigger('close')
      }
    }
  })
</script>
<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'

  .es-travel-container
    padding 8px 15px 0
    .es-travel-container-header
      display flex
      align-items center
      font-weight 500
      font-size 16px
      color $train-color-333
      margin-bottom 15px
      &::before
        display inline-block
        content ''
        width 3px
        height 15px
        margin-right 8px
        background #1473FF
    .es-travel-container-body
      .es-travel-container-body-item
        display flex
        font-size 14px
        font-weight 400
        margin-bottom 16px
        .es-travel-container-body-item-1
          width 84px
          color $train-color-666
          margin-right 28px
        .es-travel-container-body-item-2
          width 259px
          color $train-color-333
</style>
<script  name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom'
    }
  }
</script>
